export const initialStore = {
  name: '',
  city: '',
  address: '',
  state: '',
  postalCode: '',
  country: '',
  rawCategory: '',
  primaryCategories: ['Any'],
  isQueryLoading: false,
  queryStore: '',
  dataResults: [],
  downloadData: {
    downloadQueryStore: '',
    download_id: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  featureKeyword: {
    key: '',
    value: ''
  },
  description: {
    value: ''
  },
  requiredFields: [],
  reviews: {
    value: ''
  },
  menus: {
    value: ''
  },
  geoLocation: {
    value: ''
  },
  reviewsRangeQuery: { // New field for reviews range
    min: "",
    max: ""
  },
  reviewsByDate: {
  start: '',
  end: ''
  },
  firstRender: true,
  page: 1,
}
